import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { formatNumberAndCents } from '@makemydeal/dr-common-utils';
import type { FC } from 'react';
import type { CashFieldVariant } from './CashAmountPaid.interstate';
import CashFieldLayout from './CashFieldLayout.interstate';

type ReadOnlyCashFieldProps = {
    label: string;
    value: number;
    testId: string;
    variant: CashFieldVariant;
    disabled?: boolean;
};

/**
 * Read-only companion to the editable cash field, rendered by `CashFields` in both the `summary` (deal screen)
 * and `slideout` variants. Its own module rather than living in `CashFields` so that importing it does not pull
 * in the DAS selectors — the variant is a type-only import, so nothing comes along at runtime.
 */
export const ReadOnlyCashField: FC<ReadOnlyCashFieldProps> = ({ label, value, testId, variant, disabled }) => {
    const isSummaryVariant = variant === 'summary';

    return (
        <CashFieldLayout variant={variant} label={label}>
            <NumericInput
                id={testId}
                name={testId}
                data-testid={testId}
                value={formatNumberAndCents(value)}
                inputPrefix="$"
                readOnly={true}
                disabled={disabled}
                allowDecimal={true}
                label={isSummaryVariant ? label : undefined}
                displayLabel={isSummaryVariant}
                size={isSummaryVariant ? 'sm' : undefined}
            />
        </CashFieldLayout>
    );
};

export default ReadOnlyCashField;
